import React from 'react';
import { Box, Grid, Flex, Text } from 'theme-ui';
import CheckDotted from '~/assets/images/icons/check-dotted.svg';
type Props = {
  bulletPoints: Queries.ActivityPageHeaderFragment['bulletPoints'];
  backgroundColor: string;
};

const BulletPoints = ({ bulletPoints, backgroundColor }: Props) => {
  return (
    <Box sx={{ gridArea: 'bulletPoints', backgroundColor, borderRadius: '10px' }}>
      <Grid as="ul" sx={{ gap: '1.6rem', px: '1.6rem', py: '2.4rem' }}>
        {bulletPoints?.map((point) => (
          <Flex as="li" key={point} sx={{ alignItems: 'center', gap: '1.2rem' }}>
            <CheckDotted />
            <Text variant="text.button">{point}</Text>
          </Flex>
        ))}
      </Grid>
    </Box>
  );
};

export default BulletPoints;
